<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-change-color`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M38.322 5.985l-7.048-3.814c-.649-.352-1.479-.143-1.853.465L17.069 22.692l9.397 5.086L38.818 7.722c.375-.608.152-1.386-.496-1.737zm-22.61 18.91l9.398 5.086-2.713 4.404c-1.29-.685-2.162-.904-2.615-.657-.454.248-.906.672-1.357 1.272H13c1.119-1.54 1.68-2.656 1.684-3.348.003-.693-.558-1.477-1.684-2.353l2.713-4.404zM41 40a1 1 0 011 1v2a1 1 0 01-1 1H7a1 1 0 01-1-1v-2a1 1 0 011-1h34z"/></svg>
</template>
<script>

export default {
  name: 'IconChangeColor',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
